import * as React from "react"

import ContextMenu from "../../../common/contextmenu/components/ContextMenu"
import ContextMenuAction from "../../../common/contextmenu/components/ContextMenuAction"
import { IButton } from "../../../common/contextmenu"

interface Props {
    buttonsVisibility: Record<string, boolean>
    executeCallButton: (button: IButton) => void
    optionalCustomButtons: Record<string, IButton>
    optionalStandardButtons: Record<string, IButton>
    tooltip: string
}

interface State {
    isShown: boolean
}

export default class OptionalHeaderButtons extends React.PureComponent<
    Props,
    State
> {
    constructor(props: Props) {
        super(props)

        this.state = {
            isShown: false,
        }
    }

    render(): JSX.Element {
        const { optionalCustomButtons, optionalStandardButtons, tooltip } =
            this.props
        const { isShown } = this.state

        // buttons that have id can be toggled to be visible or not
        // buttons without id are always visible
        const visibleOptionalCustomButtons = Object.values(
            optionalCustomButtons,
        ).filter(this.filterVisibleButtons)
        const visibleOptionalStandardButtons = Object.values(
            optionalStandardButtons,
        ).filter(this.filterVisibleButtons)

        if (
            visibleOptionalCustomButtons.length === 0 &&
            visibleOptionalStandardButtons.length === 0
        ) {
            return <></>
        }

        const showSeparator =
            visibleOptionalCustomButtons.length > 0 &&
            visibleOptionalStandardButtons.length > 0 &&
            visibleOptionalStandardButtons[0].buttonData.type !== "Separator"

        return (
            <ContextMenu
                buttonId="optionalHeaderButtonsButton"
                hideModal={this.hideModal}
                isModalShown={isShown}
                modalId="optionalHeaderButtonsModal"
                showModal={this.showModal}
                tooltip={tooltip}
            >
                <div className="tw-py-2">
                    {visibleOptionalCustomButtons.map(
                        (button: IButton, index: number): JSX.Element => (
                            <ContextMenuAction
                                button={button}
                                executeCallAction={this.executeCallAction}
                                extraClasses="tw-py-2 tw-px-4"
                                key={index}
                            />
                        ),
                    )}

                    {showSeparator && (
                        <div className="separator-line is-dotted is-dimmed tw-py-2"></div>
                    )}

                    {visibleOptionalStandardButtons.map(
                        (button: IButton, index: number): JSX.Element => (
                            <ContextMenuAction
                                button={button}
                                executeCallAction={this.executeCallAction}
                                extraClasses="tw-py-2 tw-px-4"
                                key={index}
                            />
                        ),
                    )}
                </div>
            </ContextMenu>
        )
    }

    executeCallAction = (_event: React.MouseEvent, button: IButton): void => {
        const { executeCallButton } = this.props

        executeCallButton(button)
        this.hideModal()
    }

    showModal = (): void => this.setState({ isShown: true })

    hideModal = (): void => this.setState({ isShown: false })

    filterVisibleButtons = (button: IButton): boolean =>
        (button.id && this.props.buttonsVisibility[button.id] === true) ||
        !button.id
}
